<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2 || accessLoader" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<div class="card" *ngIf="user_type=='cdm'">
	<div class="card-header bg-primary">
		Last Mail Status
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<label class="me-5">
					Company:
					<strong>{{companyDetails?.name}}</strong>
				</label>
				<label class="me-5">
					Last mail timestamp:
					<strong>{{formatTimestamp(companyDetails?.mail_timestamp)}}</strong>
				</label>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<table class="table table-striped table-bordered table-hover comp-table">
					<thead>
						<tr class="table_head">
							<th style="width: 5% !important;">#</th>
							<th style="width: 40% !important;">Email-Id</th>
							<th style="width: 55% !important;">Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of mailStatus | keyvalue; index as i">
							<td>{{ i + 1 }}</td>
							<td>{{ item.key }}</td>
							<td>{{ getStatus(item.value) }}</td>
						</tr>
						<tr *ngIf="(mailStatus | keyvalue)?.length === 0">
							<td colspan="3" class="fw-bold text-center">
								No data available.
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<a class="btn btn-sm btn-outline-dark" [routerLink]="['/app/company']">Back</a>
			</div>
		</div>
	</div>
</div>
<div *ngIf="user_type!='cdm'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>